import { CertificationProvider } from 'app/library/certification-provider/models/certification-provider';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { CertificationProviderStatusEnum } from '../enums/certification-provider-status.enum';
import { CertificationProviderTypeEnum } from '../enums/certification-provider-type.enum';
import { CertificationProviderSearchInterface } from '../interfaces/certification-provider-search.interface';

export class SetCertificationProvider {
    static readonly type = '[CertificationProvider] SetCertificationProvider';

    constructor(public payload: CertificationProvider) {}
}

export class UnsetCertificationProvider {
    static readonly type = '[CertificationProvider] UnsetCertificationProvider';
}

export class FetchCertificationProvider {
    static readonly type = '[CertificationProvider] FetchCertificationProvider';

    constructor(public payload: string) {}
}

export class FetchCertificationProviderSuccess {
    static readonly type = '[CertificationProvider] FetchCertificationProviderSuccess';

    constructor(public payload: CertificationProvider) {}
}

export class FetchCertificationProviderFailure {
    static readonly type = '[CertificationProvider] FetchCertificationProviderFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class AddCertificationProviders {
    static readonly type = '[CertificationProvider] AddCertificationProviders';

    constructor(public payload: CertificationProvider[]) {}
}

export class CreateCertificationProvider {
    static readonly type = '[CertificationProvider] CreateCertificationProvider';

    constructor(
        public payload: {
            name: string;
            type: CertificationProviderTypeEnum;
        }
    ) {}
}

export class CreateCertificationProviderSuccess {
    static readonly type = '[CertificationProvider] CreateCertificationProviderSuccess';

    constructor(public payload: CertificationProvider) {}
}

export class CreateCertificationProviderFailure {
    static readonly type = '[CertificationProvider] CreateCertificationProviderFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCertificationProvider {
    static readonly type = '[CertificationProvider] UpdateCertificationProvider';

    constructor(
        public payload: {
            name: string;
            id: string;
        }
    ) {}
}

export class UpdateCertificationProviderSuccess {
    static readonly type = '[CertificationProvider] UpdateCertificationProviderSuccess';

    constructor(public payload: CertificationProvider) {}
}

export class UpdateCertificationProviderFailure {
    static readonly type = '[CertificationProvider] UpdateCertificationProviderFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateCertificationProviderStatus {
    static readonly type = '[CertificationProvider] UpdateCertificationProviderStatus';

    constructor(
        public payload: {
            id: string;
            status: CertificationProviderStatusEnum;
        }
    ) {}
}

export class UpdateCertificationProviderStatusSuccess {
    static readonly type = '[CertificationProvider] UpdateCertificationProviderStatusSuccess';

    constructor(public payload: CertificationProvider) {}
}

export class UpdateCertificationProviderStatusFailure {
    static readonly type = '[CertificationProvider] UpdateCertificationProviderStatusFailure';
}

export class DeleteCertificationProvider {
    static readonly type = '[CertificationProvider] DeleteCertificationProvider';

    constructor(public payload: string) {}
}

export class DeleteCertificationProviderSuccess {
    static readonly type = '[CertificationProvider] DeleteCertificationProviderSuccess';

    constructor(public payload: string) {}
}

export class DeleteCertificationProviderFailure {
    static readonly type = '[CertificationProvider] DeleteCertificationProviderFailure';

    constructor(public payload: string) {}
}

export class SetCertificationProviders {
    static readonly type = '[CertificationProvider] SetCertificationProviders';

    constructor(public payload: CertificationProvider[]) {}
}

export class FetchCertificationProviders {
    static readonly type = '[CertificationProvider] FetchCertificationProviders';

    constructor(
        public payload: {
            pageSize?: number;
            pageNumber?: number;
            search?: string;
            types: number[];
            statuses: number[];
        }
    ) {}
}

export class FetchCertificationProvidersSuccess {
    static readonly type = '[CertificationProvider] FetchCertificationProvidersSuccess';
}

export class FetchCertificationProvidersFailure {
    static readonly type = '[CertificationProvider] FetchCertificationProvidersFailure';
}

export class FetchTeamCertificationProvidersSearch {
    static readonly type = '[CertificationProvider] FetchTeamCertificationProvidersSearch';

    constructor(
        public payload: {
            pageSize?: number;
            pageNumber?: number;
            search?: string;
            data?: CertificationProviderSearchInterface;
            teamId?: string;
            includeSubteams?: boolean;
        }
    ) {}
}

export class FetchTeamMemberCertificationProvidersSearch {
    static readonly type = '[CertificationProvider] FetchTeamMemberCertificationProvidersSearch';

    constructor(
        public payload: {
            pageSize?: number;
            pageNumber?: number;
            search?: string;
            data?: CertificationProviderSearchInterface;
            userId?: string;
        }
    ) {}
}

export class FetchCertificationProvidersSearch {
    static readonly type = '[CertificationProvider] FetchCertificationProvidersSearch';

    constructor(
        public payload: {
            pageSize?: number;
            pageNumber?: number;
            search?: string;
            data?: CertificationProviderSearchInterface;
        }
    ) {}
}

export class FetchCertificationProvidersSearchSuccess {
    static readonly type = '[CertificationProvider] FetchCertificationProvidersSearchSuccess';
}

export class FetchCertificationProvidersSearchFailure {
    static readonly type = '[CertificationProvider] FetchCertificationProvidersSearchFailure';
}

export class FetchCertificatesToReplace {
    static readonly type = '[CertificationProvider] FetchCertificatesToReplace';

    constructor(
        public payload: {
            pageSize: number;
            pageNumber: number;
            certificateId: string;
        }
    ) {}
}

export class ReplaceCertificate {
    static readonly type = '[CertificationProvider] ReplaceCertificate';

    constructor(
        public payload: {
            certificateId: string;
            certificationId: string;
        }
    ) {}
}

export class ReplaceCertificateSuccess {
    static readonly type = '[CertificationProvider] ReplaceCertificateSuccess';
}

export class ReplaceCertificateFailure {
    static readonly type = '[CertificationProvider] ReplaceCertificateFailure';
}

export class ToggleSelectedCertificationProvider {
    static readonly type = '[CertificationProvider] ToggleSelectedCertificationProvider';

    constructor(public payload: string) {}
}

export class SelectFilteredCertificationProviders {
    static readonly type = '[CertificationProvider] SelectFilteredCertificationProviders';
}

export class DeselectSelectedCertificationProviders {
    static readonly type = '[CertificationProvider] DeselectSelectedCertificationProviders';
}

export class SearchCertificationProviders {
    static readonly type = '[CertificationProvider] SearchCertificationProviders';

    constructor(public payload: string) {}
}
